import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faClock,
  faEnvelopeCircleCheck,
  faEnvelopeOpenText,
  faTriangleExclamation
} from '@fortawesome/pro-regular-svg-icons';
import { format, isValid } from 'date-fns';

export type EmailDeliveryStatus =
  | 'processed'
  | 'delivered'
  | 'deferred'
  | 'bounce'
  | 'dropped'
  | 'open'
  | 'click'
  | 'spamreport'
  | 'unsubscribe'
  | 'group_unsubscribe'
  | 'group_resubscribe';

export const EMAIL_DELIVERY_ICON_MAP: Record<
  EmailDeliveryStatus,
  IconDefinition
> = {
  processed: faClock,

  delivered: faEnvelopeCircleCheck,

  deferred: faTriangleExclamation,

  bounce: faTriangleExclamation,

  dropped: faTriangleExclamation,

  open: faEnvelopeCircleCheck,

  click: faEnvelopeOpenText,

  spamreport: faTriangleExclamation,

  unsubscribe: faTriangleExclamation,

  group_unsubscribe: faTriangleExclamation,

  group_resubscribe: faTriangleExclamation
};
export const emailStatusTooltipMap: Record<string, string> = {
  processed: 'Last email status: processed, last sent on',
  delivered: 'Last email status: delivered, last sent on',
  deferred: 'Last email status: deferred, last sent on',
  bounce: 'Last email status: bounce, last sent on',
  dropped: 'Last email status: dropped, last sent on',
  open: 'Last email status: open, last sent on',
  click: 'Last email status: click, last sent on',
  spamreport: 'Last email status: spamreport, last sent on',
  unsubscribe: 'Last email status: unsubscribe, last sent on',
  group_unsubscribe: 'Last email status: group_unsubscribe, last sent on',
  group_resubscribe: 'Last email status: group_resubscribe, last sent on'
};

export function formatLocalTimestamp(timestamp: number): string {
  const date = new Date(timestamp);
  if (!isValid(date)) {
    return 'Invalid Timestamp';
  }
  return format(date, "MMM dd, yyyy 'at' HH:mm");
}
